import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import ArticlesSection from './components/ArticlesSection';
import DownloadSection from './components/DownloadSection';
import ReviewsSection from './components/ReviewsSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <ArticlesSection />
        <DownloadSection />
        <ReviewsSection />
        <FAQSection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '快猫视频 - 短视频娱乐平台官方入口',
            description: '快猫视频是一款风靡全网的短视频娱乐平台，汇聚搞笑、生活、才艺等多元视频内容，支持一键下载与分享。',
            url: 'https://www.kuaimaovideo.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '快猫视频',
              url: 'https://www.kuaimaovideo.com',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.kuaimaovideo.com/',
                },
              ],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '快猫视频怎么下载？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过官方网站直接下载快猫视频App。支持iOS和Android双平台，扫描首页二维码或在应用商店搜索"快猫视频"即可免费下载安装。',
                },
              },
              {
                '@type': 'Question',
                name: '快猫视频收费吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '快猫视频是一款完全免费的短视频娱乐平台。观看视频、下载内容、分享互动等核心功能全部免费。',
                },
              },
              {
                '@type': 'Question',
                name: '如何在快猫视频上发布自己的作品？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '下载并注册快猫视频App后，点击底部发布按钮，即可拍摄或上传您的视频作品。平台提供丰富的滤镜、特效和剪辑工具。',
                },
              },
              {
                '@type': 'Question',
                name: '快猫视频支持离线观看吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '快猫视频提供一键下载功能，您可以将喜欢的视频下载到本地，随时随地离线观看，无需消耗流量。',
                },
              },
              {
                '@type': 'Question',
                name: '快猫视频的最新版本有什么新功能？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '快猫视频最新版优化了AI推荐算法，新增了4K超清播放模式，升级了视频编辑工具，同时提升了整体运行速度和稳定性。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}